import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Image, Modal } from 'semantic-ui-react';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';


const inviteBlockStyle = {
  textAlign: 'center',
};

const inviteImageStyle = {
  margin: '0 auto',
  display: 'block',
};

const negativeButtonStyle = {
  backgroundColor: '#ee3a50',
};

const positiveButtonStyle = {
  backgroundColor: '#20c49e',
};

const okIconStyle = {
  color: '#20c49e',
};

const textAlignCenter = {
  textAlign: 'center',
};

const InviteModal = props => {
  const { email, thumbnail, closeHandler, sendHandler, inviteSentOK } = props;
  return (
    <DyzioModal
      headerText="New Invitation"
      size="tiny"
      onClose={closeHandler}
      hasActionButton
      actionButtonIcon={<Icon name="send" />}
      actionButtonContent="Send invitation"
      onActionButtonClick={sendHandler}
      shouldDisableActionButton={inviteSentOK}
    >
      <div style={textAlignCenter}>
        { inviteSentOK && <Icon style={okIconStyle} centered name="checkmark" circular size="huge" /> }
        { !inviteSentOK && <Image
          src={thumbnail}
          centered
          className="ui small circular"
          style={inviteImageStyle}
        />}
        <br />
        <p>
          { !inviteSentOK && `do you really want to send an invitation to ${email}?` }
          { inviteSentOK && 'Invite sent!' }
        </p>
      </div>
    </DyzioModal>
  );
};

InviteModal.propTypes = {
  email: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  closeHandler: PropTypes.func.isRequired,
  sendHandler: PropTypes.func.isRequired,
  inviteSentOK: PropTypes.bool.isRequired,
};

export default InviteModal;



/** WEBPACK FOOTER **
 ** ./src/components/invite-modal/index.js
 **/